import { Button, Popup } from '@quickmd-llc/design-system'
import { windowOpenArgs } from 'utils/windowOpenArgs'

type Props = {
  isOpen: boolean
  encounterUrl: string
  onClose: () => void
}

export const AuthorizeOrderReminderModal = ({ isOpen, encounterUrl, onClose }: Props) => (
  <Popup
    isOpen={isOpen}
    lockOpen
    onClose={onClose}
    styles={{ containerClassName: 'max-w-[520px] !p-sp-2' }}
    header={<div className='text-lg font-semibold text-text-dark'>Order(s) pending in Treat</div>}
    body={
      <div className='text-text-medium'>
        This visit has Treat items associated that have not been authorized. You must log in to treat.com and finalize
        the order for it to be shipped.
      </div>
    }
    footer={
      <div className='flex w-full justify-end gap-sp-1 pt-sp-1'>
        <Button
          priority='primary'
          onClick={() => {
            window.open(encounterUrl, ...windowOpenArgs)
            onClose()
          }}>
          Continue to Treat
        </Button>
        <Button priority='secondary' onClick={onClose}>
          Close
        </Button>
      </div>
    }
  />
)
